// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"ScrollMenuArrow-modulecontrolButton3J1","backButton":"ScrollMenuArrow-modulebackButton345","forwardButton":"ScrollMenuArrow-moduleforwardButton3Ts"};